// @flow
import React, { Component } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import { ChangePasswordForm } from './components';
import { Container } from './ChangePassword.style';

type Props = {};
export type StateType = {
  changePasswordSuccess: String,
  changePasswordError: String,
  getUserName: String,
};
export type DispatchPropsType = {
  changePassword: Function,
};

class ChangePassword extends Component<Props & StateType & DispatchPropsType> {
  render(): React$Element<any> {
    const { changePassword, changePasswordError, changePasswordSuccess, getUserName } = this.props;
    return (
      <Container>
        <Box>
          <Grid container className=" page__container page-section">
            <Grid container lg={12} item spacing={1}>
              <Grid lg={3} spacing={1}>
                <Grid className="page-separator">
                  <Grid className="page-separator__text">Change Password</Grid>
                </Grid>
                <Grid padding={1}>
                  <ChangePasswordForm
                    username={getUserName}
                    changePassword={changePassword}
                    setErrorMessage={changePasswordError}
                    setSuccessMessage={changePasswordSuccess}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    );
  }
}

export default ChangePassword;
